<template>
  <div class="footer">
    <p>
      本产品数据来自用户实测和主动提交。测试结果和统计数据受网络状况、终端设备、检测时间、样本大小、统计方法等多种因素影响，仅供参考；测速网不承担任何直接或间接法律责任。本产品仅统计中国大陆地区的数据，不包括中国香港、中国澳门和中国台湾的数据。
    </p>
    <p class="bottomP">
      版权所有：巨擎网络科技（济南) 有限公司 &nbsp;|&nbsp;
      <span
        class="beian"
        @click.stop="openPage(1)"
      >鲁ICP备2023028652号&nbsp;&nbsp;|&nbsp;&nbsp;
      </span>
      <img
        src="https://file2.speedtest.cn/imgs/police-icon.png"
        alt=""
        class="beian-icon"
      >
      <span
        class="beian"
        @click="openPage(2)"
      >鲁公网安备37010102006841号</span>
      ，未经授权，严禁转载。
    </p>
  </div>
</template>
<script>
export default {
  methods: {
    openPage(index) {
      if (index === 1) {
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
      } else {
        window.open('https://beian.mps.gov.cn/#/query/webSearch?code=37010102006841')
      }
    }
  }
}
</script>
<style lang="less">
.footer {
  padding: 0 10px;
  box-sizing: border-box;
  P {
    font-size: 0.12rem;
    text-align: center;
    color: #82889A;
    line-height: 14px;
  }
  p + p {
    margin-top: 10px;
  }
  .beian {
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
  }
}
.beian-icon {
  width: 16px;
  height: 16px;
  margin: 0 5px;
}
.bottomP {
  height: 20px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}
</style>
